import React from "react";
import { Link } from 'react-router-dom';
import Logout from '../service/Logout';
import "../../twintig/tw.css";
import qtig from '../../assets/qtig.svg';

function Header({ user }) {
    return (
        <header className="App-header">
            <Link to="/" title="twintig.ai">
                <img src={qtig} alt="qtig" className="App-logo" />
            </Link>
            <p className="header_text">Contracts Q&A</p>
            <Logout user={user} />
        </header> 
    );
}
export default Header;